<template>
  <v-container fluid tag="section">
    <v-layout justify-center style="flex-wrap: wrap">
      <v-btn small @click="createPayment" color="primary">{{
        $t("create_payment")
      }}</v-btn>
    </v-layout>
    <v-row>
      <v-col cols="12">
        <DataTables :exportCsv="exportCsv" @editPayment="editPayment" @viewPayment="viewPayment" :headers="headers" :tableData="tableData">
        </DataTables>
      </v-col>
    </v-row>
    <edit-payment ref="editPaymentDialog" @isUpdated="loadTable" />
  </v-container>
</template>

<script>
import editPayment from "@/app/admin/editPayment.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-payments",
  components: {
    DataTables,
    "edit-payment": editPayment,
  },
  props: {
    exportCsv: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      headers: [
        { text: this.$t("code"), value: "pagId" },
        { text: this.$t("image"), value: "logo", type: "image" },
        { text: this.$t("text"), value: "descr", type: "html" },
        { text: this.$t("active_m_s"), value: "ifActive", type: "icons" },
        { text: this.$t("time_before_pag_expire"), value: "expireText", type: "text" },
        { text: this.$t("instruction"), value: "ifInstruction", type: "icons" },
        { text: this.$t("online"), value: "ifOnline", type: "icons" },
        {
          text: this.$t("auto_confirmed"),
          value: "ifAutoConfirmed",
          type: "icons",
        },
        {
          text: this.$t("customers_pay_fees"),
          value: "ifCustomerFees",
          type: "icons",
        },
        {
          text: this.$t("options"),
          value: "options",
          type: "buttons",
        },
      ],
      tableData: [],
    };
  },

  methods: {
    emitUpdated: function (data) {
      this.loadTable();
    },

    createPayment(item) {
      this.$refs.editPaymentDialog.open("ADD", null);
    },
    editPayment(item) {
      this.$refs.editPaymentDialog.open("EDIT", item.pagId);
    },
    viewPayment(item) {
      this.$refs.editPaymentDialog.open("VIEW", item.pagId);
    },

    loadTable() {
      let _ = this;
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("GET", "/auth/portal/listAllModPagamento").then(
        (response) => {
          _.tableData = response.data.map(function (item) {
            if (item.attivo === 1)
              item.ifActive = [
                {
                  icon: "mdi-check",
                  color: "green",
                  text: _.$t("yes"),
                },
              ];
            if (item.istruzioni && item.istruzioni !== "")
              item.ifInstruction = [
                {
                  icon: "mdi-check",
                  color: "green",
                  text: _.$t("yes"),
                },
              ];
            if (item.online === 1)
              item.ifOnline = [
                {
                  icon: "mdi-check",
                  color: "green",
                  text: _.$t("yes"),
                },
              ];
            if (item.autoConfirmed === 1)
              item.ifAutoConfirmed = [
                {
                  icon: "mdi-check",
                  color: "green",
                  text: _.$t("yes"),
                },
              ];
            if (item.customerFees === 1)
              item.ifCustomerFees = [
                {
                  icon: "mdi-check",
                  color: "green",
                  text: _.$t("yes"),
                },
              ];
            item.options = [
              {
                icon: "mdi-magnify",
                color: "success",
                text: _.$t("view_payment"),
                function: "viewPayment",
              },
              {
                icon: "mdi-pencil",
                color: "primary",
                text: _.$t("edit_payment"),
                function: "editPayment",
              },
            ];

            return item;
          });
          _.isFetching = false;
        }
      );
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>